<template>
  <div>
    <div v-if="error" class="alert alert-primary bg-primary text-white border-0 show">
      {{ $t(error) }}
    </div>

    <b-form novalidate @submit.prevent="submit">
      <div class="row">
        <div class="col-lg-6">
          <validated-form-input name="name" label="Nimi" placeholder="Sisesta nimi" v-model="client.name"
                                validate="required" :validator="$validator"/>

          <validated-form-select name="type" :options="types" label="Tüüp:" placeholder="- Vali tüüp -"
                                 v-model="client.type" validate="required" :validator="$validator"/>

          <validated-form-input name="regCode" :label="regCodeLabel" placeholder="Sisesta kood" v-model="client.regCode"
                                validate="required" :validator="$validator"/>

          <validated-form-input name="vatin" label="KMKR:" placeholder="KMKR" v-model="client.vatin" validate=""
                                :validator="$validator" v-if="client.type==='company'"
                                :class="{'mb-1': parsedVatins.length > 1}">
          </validated-form-input>

          <div v-if="parsedVatins.length > 1" class="mb-2">
            <span v-for="vatin in parsedVatins" class="badge badge-sm badge-secondary-light mr-1">{{ vatin }}</span>
          </div>

          <validated-form-input name="vatRate" label="KM %:" placeholder="KM %" v-model="client.vatRate"
                                validate="decimal|max_value:99" :decimal="true"
                                :validator="$validator"/>

          <validated-form-select name="fieldOfActivity" :options="fieldsOfActivity" label="Tegevusala:"
                                 placeholder="- Vali tegevusala -" v-model="client.fieldOfActivity" validate="required"
                                 :validator="$validator"/>

          <validated-form-select name="language" :options="languages" label="Suhtluskeel:" v-model="client.language"
                                 validate="required" :validator="$validator"/>

          <validated-form-select name="manager" :options="managers" label="Kliendihaldur:"
                                 placeholder="- Vali kliendihaldur -"
                                 v-model="client.managerId" validate="required" :validator="$validator"/>
        </div>

        <div class="col-lg-6">

          <validated-form-input name="email" label="E-mail:" placeholder="E-Mail" v-model="client.email"
                                validate="required|email" :validator="$validator"/>

          <validated-form-input name="phone" label="Telefon:" placeholder="Telefon" v-model="client.phone"
                                :validate="{ required: true, regex: /^\+?[0-9 ]+$/ }" :validator="$validator"/>

          <validated-form-input name="address" label="Aadress:" placeholder="Aadress" v-model="client.address.street"
                                validate="required" :validator="$validator"/>

          <validated-form-input name="zip" label="Postiindeks:" placeholder="Postiindeks" v-model="client.address.zip"
                                validate="required" :validator="$validator"/>

          <validated-form-input name="city" label="Linn / vald:" placeholder="Linn / vald" v-model="client.address.city"
                                validate="required" :validator="$validator"/>

          <validated-form-input name="locality" label="Haldusüksus:" v-model="client.address.locality"
                                validate="" :validator="$validator"/>

          <validated-form-select name="country" :options="countries" label="Riik:" v-model="client.address.country"
                                 validate="required" :validator="$validator"/>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary" :disabled="submitting">Salvesta</submit-button>
        </div>
      </div>

    </b-form>

  </div>
</template>

<script>
import ValidatedFormInput from '@/components/ValidatedFormInput'
import ValidatedFormSelect from '@/components/ValidatedFormSelect'
import gateway from '@/services/gateway'
import {entityTypes, utils} from '@/services/Configuration'

export default {
  components: {ValidatedFormInput, ValidatedFormSelect},
  data() {
    return {
      client: {
        type: 'company',
        fieldOfActivity: null,
        language: 'et',
        address: {country: 'eesti'},
        managerId: null,
        vatin: null
      },
      types: [],
      languages: [
        {text: 'Eesti', value: 'et'},
        {text: 'Inglise', value: 'en'}
      ],
      countries: [],
      fieldsOfActivity: [],
      managers: [],
      error: null,
      submitting: false
    }
  },
  created() {
    gateway.get('/classifiers?name=client.country').then(r => {
      this.countries = utils.asSelectOptions(r.data)
    })
    gateway.get('/classifiers?name=client.activity').then(r => {
      this.fieldsOfActivity = utils.asSelectOptions(r.data)
    })
    this.types = utils.asSelectOptions(entityTypes)
    gateway.get('/users').then(r => {
      let managerSelectOptions = (users) => {
        return users.map(u => {
          return {value: u.id, text: u.fullName}
        })
      }
      this.managers.splice(1, 0, ...managerSelectOptions(r.data))
    })
  },
  methods: {
    submit() {
      if (this.submitting) return
      this.submitting = true

      this.$validator.validateAll().then(valid => {
        if (!valid) {
          this.submitting = false
          return
        }
        gateway.post('/clients', this.client)
          .then(r => {
            this.$store.commit('client', {id: r.data, name: this.client.name})
            this.$router.push('/client')
            this.$notifications.info(`Klient ${this.client.name} on lisatud`)
            this.submitting = false
            this.$emit('done')
          })
          .catch(r => {
            this.error = r.response.data.key
            this.submitting = false
          })
      })
    }
  },
  computed: {
    regCodeLabel: function () {
      return this.client.type === 'company' ? 'Registrikood:' : 'Isikukood:'
    },
    parsedVatins: function () {
      return this.client.vatin ? this.client.vatin.split(',').map(v => v.trim()).filter(v => v.length > 0) : []
    }
  }
}
</script>
